
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function RiskDisclosurePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-purple-900">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-500/20 border-2 border-red-500 flex items-center justify-center">
              <i className="ri-alert-line text-4xl text-red-400"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
              Risk Disclosure Statement
            </h1>
            <p className="text-gray-400 text-lg">
              Important Information About Cryptocurrency Trading Risks
            </p>
          </div>

          {/* Warning Banner */}
          <div className="bg-red-500/20 border-2 border-red-500 rounded-2xl p-6 mb-8">
            <h2 className="text-2xl font-bold text-red-400 mb-3 flex items-center gap-3">
              <i className="ri-error-warning-line"></i>
              HIGH RISK WARNING
            </h2>
            <p className="text-red-200 leading-relaxed">
              Cryptocurrency trading carries a high level of risk and may not be suitable for all investors. Before deciding to trade cryptocurrencies, you should carefully consider your investment objectives, level of experience, and risk appetite. The possibility exists that you could sustain a loss of some or all of your initial investment.
            </p>
          </div>

          {/* Content */}
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 md:p-12 space-y-8">
            
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-line-chart-line text-cyan-400"></i>
                1. Market Volatility Risk
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                Cryptocurrency markets are extremely volatile and can experience rapid price fluctuations:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Prices can change dramatically within minutes or hours</li>
                <li>Market movements can be unpredictable and irrational</li>
                <li>External factors (news, regulations, market sentiment) can cause sudden price swings</li>
                <li>Historical performance does not guarantee future results</li>
                <li>You may lose your entire investment in a short period</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-shield-cross-line text-cyan-400"></i>
                2. Security Risk
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                Digital assets face unique security challenges:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Hacking and cyber attacks can result in loss of funds</li>
                <li>Lost passwords or private keys cannot be recovered</li>
                <li>Phishing and social engineering attacks are common</li>
                <li>Smart contract vulnerabilities may be exploited</li>
                <li>Exchange hacks or insolvency can lead to loss of assets</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-robot-line text-cyan-400"></i>
                3. AI Trading Risk
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                Our AI-powered trading features carry additional risks:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>AI algorithms may make incorrect predictions or decisions</li>
                <li>Past AI performance does not guarantee future success</li>
                <li>Market conditions may change in ways AI cannot anticipate</li>
                <li>Technical failures may affect AI trading execution</li>
                <li>AI optimization does not eliminate trading losses</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-lightbulb-line text-cyan-400"></i>
                4. Risk Management Recommendations
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                To manage these risks, we recommend:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Only invest money you can afford to lose completely</li>
                <li>Diversify your investments across different assets</li>
                <li>Use strong security measures (2FA, strong passwords)</li>
                <li>Start with small amounts until you understand the markets</li>
                <li>Conduct thorough research before making investment decisions</li>
                <li>Set stop-loss orders to limit potential losses</li>
                <li>Seek professional financial advice if needed</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-file-warning-line text-cyan-400"></i>
                5. Acknowledgment
              </h2>
              <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-6">
                <p className="text-red-300 leading-relaxed">
                  By using PepCoin platform, you acknowledge that you have read, understood, and accepted all the risks described in this disclosure. You confirm that you are solely responsible for your trading decisions and any resulting gains or losses. PepCoin does not provide investment advice and is not responsible for your trading outcomes.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-mail-line text-cyan-400"></i>
                6. Questions or Concerns
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                If you have questions about these risks, please contact us:
              </p>
              <div className="space-y-2">
                <p className="text-cyan-400">Email: risk@pepcoin.com</p>
                <p className="text-cyan-400">Support: support@pepcoin.com</p>
                <Link to="/contact" className="text-cyan-400 hover:text-cyan-300 inline-flex items-center gap-2 cursor-pointer">
                  Contact Form <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </section>

          </div>

          {/* Footer Actions */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/terms"
              className="px-6 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-text-line mr-2"></i>
              Terms & Conditions
            </Link>
            <Link
              to="/privacy"
              className="px-6 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shield-user-line mr-2"></i>
              Privacy Policy
            </Link>
            <Link
              to="/"
              className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg text-white font-medium hover:scale-105 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
